<template>
  <div class="page-wrapper" id="main-wrapper" data-layout="horizontal" data-navbarbg="skin6" :data-sidebartype="sidebar ? 'mini-sidebar' : 'full'"
    data-sidebar-position="fixed" data-header-position="fixed">
    <app-header :user="user" :app="app" @sidebartoggler="sidebartoggler"></app-header>
    <app-sidebar :user="user" :app="app" :sidebar="sidebar" v-if="user"></app-sidebar>
    <div class="body-wrapper">
      <router-view :key="$route.fullPath" />
    </div>
  </div>
</template>
<script>
import AppHeader from '@/layout/partials/AppHeader'
import AppSidebar from '@/layout/partials/AppSidebar'
import { mapGetters } from 'vuex'
export default {
  components: { AppHeader, AppSidebar },
  computed: {
    ...mapGetters([
      'user',
      'app'
    ])
  },
  data () {
    return {
      sidebar: false
    }
  },
  created () {
    this.onInit()
  },
  methods: {
    onInit: function () {
      this.$axios({
        url: '/setapp',
        method: 'GET'
      })
        .then((resp) => {
          this.$store.dispatch('APP', resp.data)
        })
    },
    sidebartoggler: function (e) {
      this.sidebar = e || !this.sidebar
    }
  },
  mounted () {
    if (window.innerWidth < 1300) {
      this.sidebar = true
    }
    window.addEventListener('resize', () => {
      console.log(window.innerWidth < 1300)
      if (window.innerWidth < 1300) {
        this.sidebar = true
      }
    })
  }
}
</script>
<style>
.v-application--wrap{
    min-height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/layout/App.vue